// import { useRouter } from "next/router";
// chakra
import { Box, Flex } from "@chakra-ui/react";
// next
import { NextSeo } from "next-seo";
import Head from "next/head";
import React, { Fragment, ReactNode } from "react";
// Cookie
// import Cookie from 'js-cookie';
// Recoil
import { useRecoilValue } from "recoil";
import { authData } from "../State";
// Components
import Navbar from "./UI/Navbar";

interface layoutProps {
  title: string;
  customNavbar?: ReactNode;
  left: ReactNode;
  right: ReactNode;
  main: ReactNode;
  customLeftWidth?: any;
  customMainWidth?: any;
  customRightWidth?: any;
  rightDisplay?: any;
  mainDisplay?: any;
  leftDisplay?: any;
  noTopNavBar?: boolean;
  description?: string;
}

const UserLayoutv3 = ({
  title,
  left,
  right,
  main,
  customNavbar,
  customLeftWidth = { base: "100%", md: "20%" },
  customMainWidth = { base: "100%", md: "50%" },
  customRightWidth = { base: "100%", md: "30%" },
  leftDisplay = { base: "none", md: "block" },
  rightDisplay,
  mainDisplay,
  noTopNavBar,
  description,
}: layoutProps) => {
  // recoil
  const { loggedIn } = useRecoilValue(authData);
  const [testState, setTestState] = React.useState(false);

  const done = () => {
    setTestState(true);
  };

  React.useEffect(() => {
    done();
  }, []);

  return (
    <Fragment>
      <Head>
        <title>{title} &bull; Coyani</title>
        {description && <meta name="description" content={description} />}
      </Head>
      <NextSeo
        title={title}
        description={description}
        canonical="https://learntific.com"
        openGraph={{
          type: "website",
          title,
          description:
            description ||
            "We offer all the tools you need to start or grow a sustainable training business, lesson authoring, students management, messaging, payment processing and more.",
          images: [
            {
              url: "https://res.cloudinary.com/motionwares/image/upload/v1604667524/bookmark/og-large_xfd7vr.png",
              width: 1200,
              height: 630,
              alt:
                description ||
                "We offer all the tools you need to start or grow a sustainable training business, lesson authoring, students management, messaging, payment processing and more.",
            },
            {
              url: "https://res.cloudinary.com/motionwares/image/upload/v1604667506/bookmark/og-small_ymxggo.png",
              width: 600,
              height: 314,
              alt:
                description ||
                "We offer all the tools you need to start or grow a sustainable training business, lesson authoring, students management, messaging, payment processing and more.",
            },
          ],
        }}
        twitter={{
          handle: "@coyani_official",
          site: "@coyani_official",
          cardType: "summary_large_image",
        }}
      />
      {testState ? (
        <>
          {!noTopNavBar && (
            <Box
              overflowY="hidden"
              // When logged in, navbar is always shown
              // when logged out, navbar is not shown on desktop screens but only on mobile screen
              d={loggedIn ? { base: "block", lg: "none" } : "block"}>
              <Navbar />
            </Box>
          )}
          {/* Top liner */}
          <Box backgroundColor="blue.500" height="4px" pos="fixed" top={0} right={0} left={0} zIndex={9999} />
          <Flex
            mt={loggedIn ? "0px" : "80px"}
            pos="relative"
            h={loggedIn ? { md: "100vh" } : { md: "89vh" }}
            flexDir={{ base: "column", md: "row" }}
            w="100%"
            overflowY="hidden">
            {/* 1 */}
            <Flex flexDir="column" w={customLeftWidth} overflowY={{ md: "auto" }} borderRightWidth="1px" d={leftDisplay}>
              {left}
            </Flex>

            {/* 2 */}
            <Flex
              w={customMainWidth}
              overflowY={{ md: "auto" }}
              borderRightWidth="1px"
              order={{ base: 2, md: 2 }}
              overflowX="hidden"
              // justifyContent={{ md: "center" }}
              // alignItems={{ md: "center" }}
              d={mainDisplay}>
              {loggedIn && (
                <Box
                  pos="fixed"
                  bg="white"
                  w={customMainWidth}
                  // d={{ base: "none", lg: "block" }}
                  top={0}
                  zIndex={11}>
                  {/* {!!customNavbar ? customNavbar : <UserNavbar />} */}
                  {customNavbar}
                </Box>
              )}

              <Box w="100%" mt={loggedIn && !noTopNavBar ? { base: "60px", md: "80px" } : "0px"}>
                {main}
              </Box>
            </Flex>

            {/* 3 */}
            <Flex w={customRightWidth} d={rightDisplay} overflowY={{ md: "auto" }} h="100%" flexDir="column" order={{ base: 1, md: 3 }}>
              {right}
            </Flex>
          </Flex>
        </>
      ) : (
        ""
      )}
    </Fragment>
  );
};

export default UserLayoutv3;
